export default "__VITE_ASSET__yqr33Fgr__"